import React from "react";
import ReactDOM from "react-dom";

import Header from "./components/header";
import Content from "./components/content";
import Gallery from "./components/gallery";
import Contact from "./components/contact";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

const contenido = [
  {
    titulo: "¿Quienés somos?",
    contenido:
      "Bordados Zariñana es un negocio familiar que nació en León Guanajuato el año del 2020 debido a la complicada situación que trajo la pandemia del coronavirus ya que se necesitaba buscar una nueva fuente de ingreso.",
    imagen: "./assets/images/content/1.png",
  },
  {
    titulo: "Nuestra misión",
    contenido:
      "Ofrecer la mejor calidad en bordados sobre tela a un precio inigualable, con el proposito de satisfacer a nuestros clientes y que sigan confiando en nuestros servicios de bordado para que sigan personalizando sus prendas con nosotros.",
    imagen: "./assets/images/content/2.png",
  },
];

ReactDOM.render(
  <React.StrictMode>
    <div className="contacto">
      <a href="#contactanos">
        <h4
          style={{
            fontFamily: "Pacifico, cursive",
            paddingLeft: "1em",
            paddingRight: "1em",
            color: "white",
          }}
        >
          Contáctanos!!!
        </h4>
      </a>
    </div>
    <Header />
    {contenido.map((seccion, index) => {
      return <Content key={index} {...seccion} />;
    })}

    <Gallery />
    <div id="contactanos" style={{ color: "white", paddingBottom: "5em" }}>
      <Contact />
    </div>

    <div className="contacto">
      <h5
        style={{
          fontFamily: "Pacifico, cursive",
          paddingLeft: "1em",
          paddingRight: "1em",
          paddingTop: "1em",
          paddingBottom: "1em",
        }}
      >
        <a
          style={{ color: "white" }}
          href="https://www.instagram.com/elmarkesdesade/"
        >
          About the creator
        </a>
      </h5>
    </div>
  </React.StrictMode>,
  document.getElementById("root")
);
